import React from 'react'

/**
 * Cast MUI/JSS typography (and similar style objects) to React.CSSProperties.
 * Use when spreading theme.typography.* into a DOM style prop to satisfy
 * TypeScript (MUI uses JSS types that don't match React's CSSProperties).
 */
export function typographyStyle<T extends object>(
    style: T,
): React.CSSProperties {
    return style as React.CSSProperties
}

/**
 * Numeric font weights for use in makeStyles/createStyles when
 * theme.typography.fontWeightBold etc. cause type errors (FontWeight vs FontWeightProperty).
 */
export const FONT_WEIGHT_LIGHT = 300
export const FONT_WEIGHT_REGULAR = 400
export const FONT_WEIGHT_MEDIUM = 500
export const FONT_WEIGHT_BOLD = 700
